import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';
import reset from 'styled-reset';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

const GlobalStyle = createGlobalStyle`
  ${normalize}
  ${reset}
  html {
    box-sizing: border-box;
    font-size: 16px;
    margin: 0;
    padding: 0;
  }
  body {
    margin: 0;
    padding: 0;
    font-family: "Neo Sans W23", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    font-weight: 400;
    font-size: 15px;
    color: #3A3F60;
    background-color: #F5F6FA;
    overflow: hidden;
    letter-spacing: -0.005em;
  }
  *,
  *:before,
  *:after {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: inherit;
  }
  svg {
    fill: currentColor;
  }

  /* Modern scrollbars */
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: rgba(58, 63, 96, 0.16);
    border: 2px solid transparent;
    background-clip: padding-box;
    border-radius: 999px;
    transition: background 180ms cubic-bezier(0.4, 0, 0.2, 1);
  }
  ::-webkit-scrollbar-thumb:hover {
    background: rgba(58, 63, 96, 0.28);
    background-clip: padding-box;
  }
  * {
    scrollbar-width: thin;
    scrollbar-color: rgba(58, 63, 96, 0.16) transparent;
  }

  /* Selection color */
  ::selection {
    background: rgba(119, 176, 92, 0.22);
    color: inherit;
  }

  /* Crisp focus rings only on keyboard navigation */
  :focus-visible {
    outline: 2px solid rgba(119, 176, 92, 0.65);
    outline-offset: 2px;
    border-radius: 4px;
  }
  :focus:not(:focus-visible) {
    outline: none;
  }
`;

export default GlobalStyle;
